(function($) {
    $('.single-post .js-share-column').first().removeClass('d-none');
})(jQuery);